<template>
  <div class="recommend-item">
    <div class="consultation-item-ing">
      <imgContainer :src="recommendItem.cover" />
    </div>
    <div class="consultation-item-name">{{ handleChara(recommendItem.title, 20) }}</div>
    <div class="consultation-item-txt">{{ handleChara(recommendItem.introduction, 55) }}</div>
  </div>
</template>

<script setup>
import {handleChara} from "@/utils/title";
import {defineProps} from "vue";
import imgContainer from '@/components/imgContainer/index.vue'

let prop = defineProps({
  recommendItem: {
    type: Object,
    default: () => {
    },
  }
})
</script>

<style scoped lang="scss">
.recommend-item {
  cursor: pointer;
  margin-bottom: 30px;
  .consultation-item-ing {
    width: 271px;
    height: 147px;
  }

  .consultation-item-name {
    font-size: 16px;
    color: #242424;
    margin: 13px 0 10px 0;
  }

  .consultation-item-txt {
    font-size: 14px;
    color: #797979;
  }
}
</style>
